import { render, staticRenderFns } from "./part10_6.vue?vue&type=template&id=1502dbe2&"
import script from "./part10_6.vue?vue&type=script&lang=js&"
export * from "./part10_6.vue?vue&type=script&lang=js&"
import style0 from "./part10_6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports